export enum STATUS {
    SUCCESS = 1,
    ERROR_CLIENT = 0,
    ERROR_SERVER = -1,
    ERROR_OTHER = -2,
    ERROR_ORDER_EXIST = -5,
    reCAPTCHA_EXPIRED = 498,
    MISSING_reCAPTCHA = 400,
    INVALID_TOKEN = 403,
    SERVER_ERROR = 500
}
